import { axios } from '@Root/API'

export const getDynamic = () => {
	return axios.get('get-data-for-program')
}
